// The alert chime — a short falling tone made in the browser (no sound file). Shared by the OSR lead alerts
// (components/osr/OsrAlerts.js) and the website chat's "someone wants a person" alerts
// (components/webChat/LiveChatAlerts.js). One audio channel for the life of the page.
let audio = null;

export function chime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audio) audio = new Ctx();
    if (audio.state === "suspended") audio.resume().catch(() => {});
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.connect(gain);
    gain.connect(audio.destination);
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, audio.currentTime);
    osc.frequency.setValueAtTime(660, audio.currentTime + 0.12);
    gain.gain.setValueAtTime(0.3, audio.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, audio.currentTime + 0.3);
    osc.start(audio.currentTime);
    osc.stop(audio.currentTime + 0.3);
    osc.onended = () => { osc.disconnect(); gain.disconnect(); };
  } catch {
    /* no sound on this device — the card still shows */
  }
}
